import { v1Get } from '@/services/v1Api';

/**
 * Map backend timeline-projects response to frontend shape.
 * Backend returns crew: { unassigned, confirmed, outstanding }; we flatten to top-level.
 */
function mapTimelineProjectFromApi(p) {
  if (!p || p.id == null) return null;
  const crew = p.crew || {};
  return {
    id: p.id,
    name: p.name ?? p.title ?? `Project ${p.id}`,
    start_date: p.start_date ?? p.start,
    end_date: p.end_date ?? p.end,
    unassigned: crew.unassigned ?? 0,
    confirmed: crew.confirmed ?? 0,
    outstanding: crew.outstanding ?? 0
  };
}

/**
 * Fetch projects for the crew timeline from the backend.
 * GET /api/v1/crewing/timeline-projects returns projects with crew: { unassigned, confirmed, outstanding }.
 * Optional start_date / end_date (YYYY-MM-DD) restrict to projects overlapping that range (e.g. for past months).
 * Per-project crew-assignments are loaded when the user opens that project (Crew Widget).
 * @param {string} [startDate] - YYYY-MM-DD, optional
 * @param {string} [endDate] - YYYY-MM-DD, optional
 * @returns {Promise<Array<{ id, name, start_date, end_date, unassigned, confirmed, outstanding }>>}
 */
export async function getCrewTimelineProjects(startDate = null, endDate = null) {
  const params = {};
  if (startDate) params.start_date = startDate;
  if (endDate) params.end_date = endDate;
  const { data } = await v1Get('/api/v1/crewing/timeline-projects', params);
  const list = Array.isArray(data) ? data : [];
  return list.map(mapTimelineProjectFromApi).filter(Boolean);
}
